import axios from "axios";

const generateAppQrLink = (params) => axios.post(`/api/v1/data-token-managements/generate-link`, params);

const ApiTokenManagement = {
  generateAppQrLink
};

export default ApiTokenManagement;